import { Calendar, SeasonFields, SeasonNumberDate } from '@/views/seasons/seasons.types';
import { ObjectWithStringKeys }                     from '@/types';

export function fields(): SeasonFields {
  return {
    color: '',
    name: '',
    code: '',
  };
}

export function generateDays(length: number): ObjectWithStringKeys<null> {
  const result: ObjectWithStringKeys<null> = {};

  for (let i = 1; i <= length; i += 1) {
    result[ i ] = null;
  }

  return result;
}


export function getDatesWithCode(calendar: Calendar, code: string): SeasonNumberDate[] {
  return Object.keys(calendar)
    .reduce((acc: SeasonNumberDate[], monthIndex: string) => {
      const month: ObjectWithStringKeys<string | null> = calendar[ monthIndex ];
      if (month) {
        return [
          ...acc,
          ...Object.keys(month)
            .reduce((accumulator: SeasonNumberDate[], dayIndex: string): SeasonNumberDate[] => {
              const day: string | null = month[ dayIndex ];
              if (day === code) {
                return [ ...accumulator, { dayNumber: +dayIndex, monthNumber: +monthIndex + 1 }];
              }
              return accumulator;
            }, []),
        ];
      }
      return acc;
    }, []);
}

export function clearCalendarDayCode(calendar: Calendar, originalCode: string | null): void {
  Object.keys(calendar)
    .forEach((monthIndex: string) => {
      const month: { [ s: string ]: string | null } = calendar[ monthIndex ];

      Object.keys(month)
        .forEach((dayIndex: string) => {
          const day: string | null = month[ dayIndex ];

          if (day === originalCode) {
            (calendar[ monthIndex ] as any)[ dayIndex ] = null;
          }
        });
    });
}
